import { SignolUtils } from "@src/utils";

const TextLink = ({
  onClick,
  to,
  text,
  side = "center",
  trackingActionKey = undefined,
}) => {
  return (
    <div className={`text-${side} w-full mb-3`}>
      <div
        className="text-primary-500 underline cursor-pointer"
        to={to}
        onClick={onClick}
        {...(!!trackingActionKey
          ? SignolUtils.makeTrackableDataAttributes({
              actionKey: trackingActionKey,
              newUrl: to,
            })
          : {})}
      >
        {text}
      </div>
    </div>
  );
};

export default TextLink;
